import { create } from "zustand";
import { produce } from "immer";

const initialAlumniState = {
  agree: false,
  cardType: null,
  pickupLocation: null,
  surname: null,
  otherNames: null,
  chineseName: null,
  idType: "hkid",
  idNumber: null,
  photo: null,
  addrHome: null,
  addrContact: null,
  phone: null,
  email: null,
  programme: null,
  studentNo: null,
  gradYear: null,
  afcardOwned: false,
  afcard: null,
  afcardCopy: null,
  afcardValid: null,
};

const initialTeacherState = {
  agree: false,
  cardType: null,
  pickupLocation: null,
  surname: null,
  otherNames: null,
  chineseName: null,
  idType: "hkid",
  idNumber: null,
  photo: null,
  addrHome: null,
  addrContact: null,
  phone: null,
  email: null,
  schoolName: null,
  schoolPosition: null,
  schoolProof: null,
  schoolProofAck: false,
};

const initialIndividualState = {
  agree: false,
  cardType: null,
  pickupLocation: null,
  surname: null,
  otherNames: null,
  chineseName: null,
  idType: "hkid",
  idNumber: null,
  photo: null,
  institute: null,
  position: null,
  addrHome: null,
  addrContact: null,
  phone: null,
  email: null,
  recommLetter: null,
};

const initialOrganisationState = {
  agree: false,
  cardType: null,
  pickupLocation: null,
  org: null,
  orgChi: null,
  contactSurname: null,
  contactOtherNames: null,
  contactChiName: null,
  contactPosition: null,
  contactAddr: null,
  phone: null,
  email: null,
  orgProof: null,
};

const initialSchoolState = {
  agree: false,
  cardType: 'reader',
  pickupLocation: null,
  psName: null,
  psNameChi: null,
  psPrincipalSurname: null,
  psPrincipalOtherNames: null,
  psPrincipalChiName: null,
  psAddr: null,
  phone: null,
  email: null,
  psProof: null,
};

export const useAlumniStore = create((set) => ({
  form: initialAlumniState,
  ref: null,
  updateForm: (name, value) =>
    set(
      produce((state) => {
        state.form[name] = value;
      })
    ),
  updateRef: (ref) =>
    set(
      produce((state) => {
        state.ref = ref;
      })
    ),
  clearForm: () => set({ form: initialAlumniState }),
}));

export const useTeacherStore = create((set) => ({
  form: initialTeacherState,
  ref: null,
  updateForm: (name, value) =>
    set(
      produce((state) => {
        state.form[name] = value;
      })
    ),
  updateRef: (ref) =>
    set(
      produce((state) => {
        state.ref = ref;
      })
    ),
  clearForm: () => set({ form: initialTeacherState }),
}));

export const useIndividualStore = create((set) => ({
  form: initialIndividualState,
  ref: null,
  updateForm: (name, value) =>
    set(
      produce((state) => {
        state.form[name] = value;
      })
    ),
  updateRef: (ref) =>
    set(
      produce((state) => {
        state.ref = ref;
      })
    ),
  clearForm: () => set({ form: initialIndividualState }),
}));

export const useOrganisationStore = create((set) => ({
  form: initialOrganisationState,
  ref: null,
  updateForm: (name, value) =>
    set(
      produce((state) => {
        state.form[name] = value;
      })
    ),
  updateRef: (ref) =>
    set(
      produce((state) => {
        state.ref = ref;
      })
    ),
  clearForm: () => set({ form: initialOrganisationState }),
}));

export const useSchoolStore = create((set) => ({
  form: initialSchoolState,
  ref: null,
  updateForm: (name, value) =>
    set(
      produce((state) => {
        state.form[name] = value;
      })
    ),
  updateRef: (ref) =>
    set(
      produce((state) => {
        state.ref = ref;
      })
    ),
  clearForm: () => set({ form: initialSchoolState }),
}));